import useDirectRedirectToItem from '@/composables/useDirectRedirectToItem'

export default ({ pending, $store, $router }) => {
  const { redirectDirect, setForceRedirect } = useDirectRedirectToItem()
  const addToast = toast => $store.commit('notifications/ADD_TOAST', toast)

  const storeEditTicket = _ => $store.dispatch('ticket/editTicket')

  const editTicket = _ => {
    if (pending.value.editTicket) {
      return
    }

    if (redirectDirect.value) {
      setForceRedirect(true)
    }

    storeEditTicket().then(({ ticket, errors }) => {
      if (errors) {
        setForceRedirect(false)
        addToast({
          msg: 'Erstellung fehlgeschlagen',
          type: 'error',
        })
        return
      }

      addToast({
        msg: 'Ticket erfolgreich erstellt',
        type: 'success',
      })

      if (redirectDirect.value) {
        $router.push({
          name: 'tickets-item',
          params: { id: ticket.id },
        })
      } else {
        $router.push({ path: '/Tickets' })
      }
    })
  }

  return {
    editTicket,
  }
}
